import { StarIcon } from "@/assets/icons";
import { toast } from "@/components/ui/toast";
import { Square2StackIcon } from "@heroicons/react/20/solid";

/* Prop Types */
interface VideoCopilotSummaryPanelProps {
  summary: string;
}

/**
 * VideoCopilotSummaryPanel component
 *
 * Smaller, top-right variant of the Copilot Summary block for the video in-depth right panel.
 */
export const VideoCopilotSummaryPanel = ({ summary }: VideoCopilotSummaryPanelProps) => {
  /* Handlers */
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(summary);
      toast({ title: "Summary copied to clipboard", type: "success" });
    } catch {
      toast({ title: "Failed to copy summary, please try again", type: "error" });
    }
  };

  /* Render */
  return (
    <div data-theme="light" className="flex flex-col gap-2 p-4 rounded-lg bg-linear-to-br from-violet-800 to-pink-600 text-white">
      <div className="flex items-center gap-2.5">
        <StarIcon className="size-4.5" />
        <span className="flex-1 font-semibold">Copilot Summary</span>
        <button type="button" onClick={handleCopy} aria-label="Copy summary" className="flex items-center justify-center size-[26px] rounded-xs shrink-0 cursor-pointer hover:bg-white/10">
          <Square2StackIcon className="size-4.5" />
        </button>
      </div>
      <p className="text-sm">{summary}</p>
    </div>
  );
};
